/**
 * AppLayout — shell entry point.
 *
 * FmShellLayout is the ONLY shell for /app/*. Legacy shell deleted (mywox.3).
 */
import React from 'react';
import FmShellLayout from './FmShellLayout';

const AppLayout: React.FC = () => {
  return <FmShellLayout />;
};

export default AppLayout;
